module.exports = __webpack_public_path__ + "static/coubix-29811aaf4c0cabdb555829d019eec247.jpg";